// @flow
import invariant from 'invariant';
import * as React from 'react';
import { connect } from 'react-redux';
import TabContext from 'containers/TabContext';
import ShareNewListingModalLoadable from 'modals/ShareNewListingModalLoadable';
import ShareListingModalContainerLoadable from 'modals/ShareListingModalContainerLoadable';
import FlagListingModalContainerLoadable from 'modals/FlagListingModalContainerLoadable';
import UserProfileModalContainerLoadable from 'modals/UserProfileModalContainerLoadable';
import EmailSignupModalContainerLoadable from 'modals/EmailSignupModalContainerLoadable';
import VerifyEmailModalContainerLoadable from 'modals/VerifyEmailModalContainerLoadable';
import InformationRequiredModalContainerLoadable from 'modals/InformationRequiredModalContainerLoadable';
import AdminRequestModalContainerLoadable from 'modals/AdminRequestModalContainerLoadable';
import LeadsNotificationPreferencesModalContainerLoadable from 'modals/LeadsNotificationPreferencesModalContainerLoadable';
import NotificationPreferencesModalContainerLoadable from 'modals/NotificationPreferencesModalContainerLoadable';
import LoginModalContainerLoadable from 'modals/LoginModalContainerLoadable';
import SignupModalContainerLoadable from 'modals/SignupModalContainerLoadable';
import ForgotPasswordModalContainerLoadable from 'modals/ForgotPasswordModalContainerLoadable';
import DeleteAccountModalContainerLoadable from 'modals/DeleteAccountModalContainerLoadable';
import RemovePaymentMethodModalContainerLoadable from 'modals/RemovePaymentMethodModalContainerLoadable';
import DeleteListingModalContainerLoadable from 'modals/DeleteListingModalContainerLoadable';
import DeleteOrgModalContainerLoadable from 'modals/DeleteOrgModalContainerLoadable';
import DeleteGroupModalContainerLoadable from 'modals/DeleteGroupModalContainerLoadable';
import AddAdminModalContainerLoadable from 'modals/AddAdminModalContainerLoadable';
import ConfirmationModalContainerLoadable from 'modals/ConfirmationModalContainerLoadable';
import AddOrEditImageModalContainerLoadable from 'modals/AddOrEditImageModalContainerLoadable';
import MediaGalleryModalContainerLoadable from 'modals/MediaGalleryModalContainerLoadable';
import VatNumberModalContainerLoadable from 'modals/VatNumberModalContainerLoadable';
import HideRepostedListingsModalContainerLoadable from 'modals/HideRepostedListingsModalContainerLoadable';
import GradFairRegisterModalContainerLoadable from 'modals/GradFairRegisterModalContainerLoadable';
import SelectContentBlockModalContainerLoadable from 'modals/SelectContentBlockModalContainerLoadable';
import DeleteContentModalContainerLoadable from 'modals/DeleteContentModalContainerLoadable';
import DeleteScheduledContentModalContainerLoadable from 'modals/DeleteScheduledContentModalContainerLoadable';
import PreviewScheduledContentModalContainerLoadable from 'modals/PreviewScheduledContentModalContainerLoadable';
import DeferQueueItemModalContainerLoadable from 'modals/DeferQueueItemModalContainerLoadable';
import ApproveItemModalContainerLoadable from 'modals/ApproveItemModalContainerLoadable';
import RejectItemModalContainerLoadable from 'modals/RejectItemModalContainerLoadable';
import MarkAsSpamModalContainerLoadable from 'modals/MarkAsSpamModalContainerLoadable';
import FreezeListingModalContainerLoadable from 'modals/FreezeListingModalContainerLoadable';
import StaffDeleteOrgModalContainerLoadable from 'modals/StaffDeleteOrgModalContainerLoadable';
import StaffDeleteGroupModalContainerLoadable from 'modals/StaffDeleteGroupModalContainerLoadable';
import StaffChangePasswordModalContainerLoadable from 'modals/StaffChangePasswordModalContainerLoadable';
import ConfirmMergeOrgModalLoadable from 'modals/ConfirmMergeOrgModalLoadable';
import ConfirmMergeGroupModalLoadable from 'modals/ConfirmMergeGroupModalLoadable';
import RefundPaymentModalContainerLoadable from 'modals/RefundPaymentModalContainerLoadable';
import VoidLineItemModalContainerLoadable from 'modals/VoidLineItemModalContainerLoadable';
import CancelCreditsModalContainerLoadable from 'modals/CancelCreditsModalContainerLoadable';
import CreateSupportCaseModalContainerLoadable from 'modals/CreateSupportCaseModalContainerLoadable';
import DeleteCategoryModalContainerLoadable from 'modals/DeleteCategoryModalContainerLoadable';
import DeleteSubsiteModalContainerLoadable from 'modals/DeleteSubsiteModalContainerLoadable';
import EditUserProfileModalContainerLoadable from 'modals/EditUserProfileModalContainerLoadable';
import GradProgramContactModalContainerLoadable from 'modals/GradProgramContactModalContainerLoadable';
import StaffGradFairRegisterModalContainerLoadable from 'modals/StaffGradFairRegisterModalContainerLoadable';
import StaffGradFairCancelRegistrationModalContainerLoadable from 'modals/StaffGradFairCancelRegistrationModalContainerLoadable';
import StaffGradFairRegistrationSponsorOrHostModalContainerLoadable from 'modals/StaffGradFairRegistrationSponsorOrHostModalContainerLoadable';
import StaffGradFairAddToWaitlistModalContainerLoadable from 'modals/StaffGradFairAddToWaitlistModalContainerLoadable';
import StaffGradFairInviteModalContainerLoadable from 'modals/StaffGradFairInviteModalContainerLoadable';
import DeleteEmailPromoModalContainerLoadable from 'modals/DeleteEmailPromoModalContainerLoadable';
import GradFairsShareContactModalLoadable from 'modals/GradFairsShareContactModalLoadable';
import GradFairsInformationRequiredModalContainerLoadable from 'modals/GradFairsInformationRequiredModalContainerLoadable';
import AddIdealistDaysMapPinModalContainerLoadable from 'modals/idealistDaysMap/AddIdealistDaysMapPinModalContainerLoadable';
import MaybeSetIdealistDaysMapProfileModalContainerLoadable from 'modals/idealistDaysMap/MaybeSetIdealistDaysMapProfileModalContainerLoadable';
import ViewIdealistDaysMapPinModalContainerLoadable from 'modals/idealistDaysMap/ViewIdealistDaysMapPinModalContainerLoadable';
import IdealistDaysMapZoomModalContainerLoadable from 'modals/idealistDaysMap/IdealistDaysMapZoomModalContainerLoadable';
import IdealistDaysMapInstructionsModalContainerLoadable from 'modals/idealistDaysMap/IdealistDaysMapInstructionsModalContainerLoadable';
import IdealistDaysMapAlertModalContainerLoadable from 'modals/idealistDaysMap/IdealistDaysMapAlertModalContainerLoadable';
import GenericUncloseableModalLoadable from 'modals/GenericUncloseableModalLoadable';
import DeleteHeroSearchModalContainerLoadable from 'modals/DeleteHeroSearchModalContainerLoadable';
import DeleteJobFamilyModalContainerLoadable from 'modals/DeleteJobFamilyModalContainerLoadable';
import DeleteJobTitleModalContainerLoadable from 'modals/DeleteJobTitleModalContainerLoadable';
import DeleteJobSynonymModalContainerLoadable from 'modals/DeleteJobSynonymModalContainerLoadable';
import GradProgramContactSeeMoreInfoModal from 'modals/GradProgramContactSeeMoreInfoModal';
import StaffGradFairRemoveFromWaitlistModalContainerLoadable from 'modals/StaffGradFairRemoveFromWaitlistModalContainerLoadable';
import StaffLoginAsModalContainerLoadable from 'modals/StaffLoginAsModalContainerLoadable';
import FinishOauthSignupModalContainerLoadable from 'modals/FinishOauthSignupModalContainerLoadable';
import AddEditWorkHistoryJobModalContainerLoadable from 'modals/AddEditWorkHistoryJobModalContainerLoadable';
import DeleteWorkHistoryJobModalContainerLoadable from 'modals/DeleteWorkHistoryJobModalContainerLoadable';
import AddEditIntegrationModalContainerLoadable from 'modals/AddEditIntegrationModalContainerLoadable';
import AutoPublishIntegrationModalContainerLoadable from 'modals/AutoPublishIntegrationModalContainerLoadable';
import DeleteIntegrationModalContainerLoadable from 'modals/DeleteIntegrationModalContainerLoadable';
import DuplicateContentModalContainerLoadable from 'modals/DuplicateContentModalContainerLoadable';
import waitForElement from 'utils/waitForElement';
import { setError } from '../redux/main/actions/error';

const { useState, useRef, useEffect, useContext } = React;

export type ModalType =
  | 'SHARE_NEW_LISTING'
  | 'SHARE_LISTING'
  | 'FLAG_LISTING'
  | 'USER_PROFILE'
  | 'EMAIL_SIGNUP'
  | 'VERIFY_EMAIL'
  | 'INFORMATION_REQUIRED'
  | 'ADMIN_REQUEST'
  | 'LEADS_NOTIFICATION_PREFERENCES'
  | 'NOTIFICATION_PREFERENCES'
  | 'LOGIN'
  | 'SIGNUP'
  | 'FORGOT_PASSWORD'
  | 'DELETE_ACCOUNT'
  | 'REMOVE_PAYMENT_METHOD'
  | 'DELETE_LISTING'
  | 'DELETE_ORG'
  | 'DELETE_GROUP'
  | 'ADD_ADMIN'
  | 'CONFIRMATION'
  | 'ADD_OR_EDIT_IMAGE'
  | 'MEDIA_GALLERY'
  | 'VAT_NUMBER'
  | 'SET_BOARD_TOKEN'
  | 'SET_CUSTOMER_ID'
  | 'AUTO_PUBLISH_GREENHOUSE'
  | 'AUTO_PUBLISH_JAZZHR'
  | 'HIDE_REPOSTED_LISTINGS'
  | 'GRAD_FAIR_REGISTER'
  | 'SELECT_CONTENT_BLOCK'
  | 'DELETE_CONTENT'
  | 'DELETE_SCHEDULED_CONTENT'
  | 'PREVIEW_SCHEDULED_CONTENT'
  | 'DEFER_QUEUE_ITEM'
  | 'APPROVE_ITEM'
  | 'REMOVE_ITEM'
  | 'REJECT_ITEM'
  | 'MARK_AS_SPAM'
  | 'FREEZE_LISTING'
  | 'CREATE_SUPPORT_CASE'
  | 'STAFF_DELETE_ORG'
  | 'STAFF_DELETE_GROUP'
  | 'STAFF_CHANGE_PASSWORD'
  | 'CONFIRM_MERGE_ORG'
  | 'CONFIRM_MERGE_GROUP'
  | 'DELETE_CATEGORY'
  | 'DELETE_SUBSITE'
  | 'EDIT_USER_PROFILE'
  | 'GRAD_PROGRAM_CONTACT'
  | 'REFUND_PAYMENT_MODAL'
  | 'VOID_LINE_ITEM'
  | 'CANCEL_CREDITS'
  | 'STAFF_GRAD_FAIR_REGISTER'
  | 'STAFF_GRAD_FAIR_CANCEL_REGISTRATION'
  | 'STAFF_GRAD_FAIR_SPONSOR_OR_HOST'
  | 'STAFF_GRAD_FAIR_ADD_TO_WAITLIST'
  | 'STAFF_GRAD_FAIR_INVITE'
  | 'STAFF_DELETE_EMAIL_PROMO'
  | 'GRAD_FAIRS_SHARE_CONTACT'
  | 'GRAD_FAIRS_INFORMATION_REQUIRED'
  | 'ADD_IDEALIST_DAYS_MAP_PIN'
  | 'MAYBE_SET_IDEALIST_DAYS_MAP_PROFILE'
  | 'VIEW_IDEALIST_DAYS_MAP_PIN'
  | 'IDEALIST_DAYS_MAP_ZOOM'
  | 'IDEALIST_DAYS_MAP_INSTRUCTIONS'
  | 'IDEALIST_DAYS_MAP_ALERT'
  | 'GENERIC_UNCLOSEABLE'
  | 'DELETE_HERO_SEARCH'
  | 'DELETE_JOB_FAMILY'
  | 'DELETE_JOB_TITLE'
  | 'DELETE_JOB_SYNONYM'
  | 'GRAD_PROGRAM_CONTACT_SEE_MORE_INFO'
  | 'STAFF_GRAD_FAIR_REMOVE_FROM_WAITLIST'
  | 'STAFF_LOGIN_AS_USER'
  | 'FINISH_OAUTH_SIGNUP'
  | 'ADD_EDIT_WORK_HISTORY_JOB'
  | 'DELETE_WORK_HISTORY_JOB'
  | 'ADD_EDIT_INTEGRATION'
  | 'AUTO_PUBLISH_INTEGRATION'
  | 'DELETE_INTEGRATION'
  | 'DUPLICATE_CONTENT';

const MODAL_COMPONENTS: { [ModalType]: Object } = {
  SHARE_NEW_LISTING: ShareNewListingModalLoadable,
  SHARE_LISTING: ShareListingModalContainerLoadable,
  FLAG_LISTING: FlagListingModalContainerLoadable,
  USER_PROFILE: UserProfileModalContainerLoadable,
  EMAIL_SIGNUP: EmailSignupModalContainerLoadable,
  VERIFY_EMAIL: VerifyEmailModalContainerLoadable,
  INFORMATION_REQUIRED: InformationRequiredModalContainerLoadable,
  ADMIN_REQUEST: AdminRequestModalContainerLoadable,
  LEADS_NOTIFICATION_PREFERENCES: LeadsNotificationPreferencesModalContainerLoadable,
  NOTIFICATION_PREFERENCES: NotificationPreferencesModalContainerLoadable,
  LOGIN: LoginModalContainerLoadable,
  SIGNUP: SignupModalContainerLoadable,
  FORGOT_PASSWORD: ForgotPasswordModalContainerLoadable,
  DELETE_ACCOUNT: DeleteAccountModalContainerLoadable,
  REMOVE_PAYMENT_METHOD: RemovePaymentMethodModalContainerLoadable,
  DELETE_LISTING: DeleteListingModalContainerLoadable,
  DELETE_ORG: DeleteOrgModalContainerLoadable,
  DELETE_GROUP: DeleteGroupModalContainerLoadable,
  ADD_ADMIN: AddAdminModalContainerLoadable,
  CONFIRMATION: ConfirmationModalContainerLoadable,
  ADD_OR_EDIT_IMAGE: AddOrEditImageModalContainerLoadable,
  MEDIA_GALLERY: MediaGalleryModalContainerLoadable,
  VAT_NUMBER: VatNumberModalContainerLoadable,
  HIDE_REPOSTED_LISTINGS: HideRepostedListingsModalContainerLoadable,
  GRAD_FAIR_REGISTER: GradFairRegisterModalContainerLoadable,
  SELECT_CONTENT_BLOCK: SelectContentBlockModalContainerLoadable,
  DELETE_CONTENT: DeleteContentModalContainerLoadable,
  DELETE_SCHEDULED_CONTENT: DeleteScheduledContentModalContainerLoadable,
  PREVIEW_SCHEDULED_CONTENT: PreviewScheduledContentModalContainerLoadable,
  DEFER_QUEUE_ITEM: DeferQueueItemModalContainerLoadable,
  REJECT_ITEM: RejectItemModalContainerLoadable,
  APPROVE_ITEM: ApproveItemModalContainerLoadable,
  MARK_AS_SPAM: MarkAsSpamModalContainerLoadable,
  FREEZE_LISTING: FreezeListingModalContainerLoadable,
  CREATE_SUPPORT_CASE: CreateSupportCaseModalContainerLoadable,
  STAFF_DELETE_ORG: StaffDeleteOrgModalContainerLoadable,
  STAFF_DELETE_GROUP: StaffDeleteGroupModalContainerLoadable,
  STAFF_CHANGE_PASSWORD: StaffChangePasswordModalContainerLoadable,
  CONFIRM_MERGE_ORG: ConfirmMergeOrgModalLoadable,
  CONFIRM_MERGE_GROUP: ConfirmMergeGroupModalLoadable,
  DELETE_CATEGORY: DeleteCategoryModalContainerLoadable,
  DELETE_SUBSITE: DeleteSubsiteModalContainerLoadable,
  EDIT_USER_PROFILE: EditUserProfileModalContainerLoadable,
  GRAD_PROGRAM_CONTACT: GradProgramContactModalContainerLoadable,
  REFUND_PAYMENT_MODAL: RefundPaymentModalContainerLoadable,
  VOID_LINE_ITEM: VoidLineItemModalContainerLoadable,
  CANCEL_CREDITS: CancelCreditsModalContainerLoadable,
  STAFF_GRAD_FAIR_REGISTER: StaffGradFairRegisterModalContainerLoadable,
  STAFF_GRAD_FAIR_CANCEL_REGISTRATION: StaffGradFairCancelRegistrationModalContainerLoadable,
  STAFF_GRAD_FAIR_SPONSOR_OR_HOST: StaffGradFairRegistrationSponsorOrHostModalContainerLoadable,
  STAFF_GRAD_FAIR_ADD_TO_WAITLIST: StaffGradFairAddToWaitlistModalContainerLoadable,
  STAFF_GRAD_FAIR_INVITE: StaffGradFairInviteModalContainerLoadable,
  STAFF_DELETE_EMAIL_PROMO: DeleteEmailPromoModalContainerLoadable,
  GRAD_FAIRS_SHARE_CONTACT: GradFairsShareContactModalLoadable,
  GRAD_FAIRS_INFORMATION_REQUIRED: GradFairsInformationRequiredModalContainerLoadable,
  ADD_IDEALIST_DAYS_MAP_PIN: AddIdealistDaysMapPinModalContainerLoadable,
  MAYBE_SET_IDEALIST_DAYS_MAP_PROFILE: MaybeSetIdealistDaysMapProfileModalContainerLoadable,
  VIEW_IDEALIST_DAYS_MAP_PIN: ViewIdealistDaysMapPinModalContainerLoadable,
  IDEALIST_DAYS_MAP_ZOOM: IdealistDaysMapZoomModalContainerLoadable,
  IDEALIST_DAYS_MAP_INSTRUCTIONS: IdealistDaysMapInstructionsModalContainerLoadable,
  IDEALIST_DAYS_MAP_ALERT: IdealistDaysMapAlertModalContainerLoadable,
  GENERIC_UNCLOSEABLE: GenericUncloseableModalLoadable,
  DELETE_HERO_SEARCH: DeleteHeroSearchModalContainerLoadable,
  DELETE_JOB_FAMILY: DeleteJobFamilyModalContainerLoadable,
  DELETE_JOB_TITLE: DeleteJobTitleModalContainerLoadable,
  DELETE_JOB_SYNONYM: DeleteJobSynonymModalContainerLoadable,
  GRAD_PROGRAM_CONTACT_SEE_MORE_INFO: GradProgramContactSeeMoreInfoModal,
  STAFF_GRAD_FAIR_REMOVE_FROM_WAITLIST: StaffGradFairRemoveFromWaitlistModalContainerLoadable,
  STAFF_LOGIN_AS_USER: StaffLoginAsModalContainerLoadable,
  FINISH_OAUTH_SIGNUP: FinishOauthSignupModalContainerLoadable,
  ADD_EDIT_WORK_HISTORY_JOB: AddEditWorkHistoryJobModalContainerLoadable,
  DELETE_WORK_HISTORY_JOB: DeleteWorkHistoryJobModalContainerLoadable,
  ADD_EDIT_INTEGRATION: AddEditIntegrationModalContainerLoadable,
  AUTO_PUBLISH_INTEGRATION: AutoPublishIntegrationModalContainerLoadable,
  DELETE_INTEGRATION: DeleteIntegrationModalContainerLoadable,
  DUPLICATE_CONTENT: DuplicateContentModalContainerLoadable
};

type Ref = { current: null | HTMLElement };

const Modal = ({
  type,
  modalProps
}: {
  type?: ModalType,
  modalProps?: Object
}) => {
  const [modalContext, setModalContext] = useState(null);
  const [focused, setFocused] = useState(false);

  const modalContainerRef: Ref = useRef(null);

  const isTabbing = useContext(TabContext);

  useEffect(
    () => {
      setFocused(false);
    },
    [type]
  );

  useEffect(
    () => {
      if (!focused) {
        setFocused(true);
        if (type) {
          const modalContextElement = document.querySelector('*:focus');
          setModalContext(modalContextElement);
          waitForElement(() => {
            if (modalContainerRef && modalContainerRef.current) {
              const container = modalContainerRef.current;
              const els = Array.from(
                container.querySelectorAll(
                  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                )
              );
              if (isTabbing) {
                return (
                  els.find(el =>
                    el.matches(':not([data-modal-focus="false"])')
                  ) || els[0]
                );
              }
              const firstFocusableElement =
                els.find(el => el.matches('[data-modal-focus="true"]')) ||
                els.find(el =>
                  el.matches(':not([data-modal-focus="false"])')
                ) ||
                els[0];
              return firstFocusableElement;
            }
          }, 200)
            .then(el => {
              el.focus();
            })
            .catch(() => {});
        } else if (modalContext) {
          modalContext.focus();
          setModalContext(null);
        }
      }
    },
    [type, modalContext, isTabbing, focused]
  );

  if (!type) {
    return null;
  }

  const ModalComponent = MODAL_COMPONENTS[type];
  invariant(ModalComponent, `Invalid modal type: ${type}`);

  return (
    <div ref={modalContainerRef}>
      <ModalComponent {...modalProps} />
    </div>
  );
};

type OwnProps = { type?: ModalType, props?: Object };

type Props = { ...$Exact<OwnProps>, setError: Function };

class ModalRoot extends React.Component<Props> {
  componentDidCatch(error: Error, info: { componentStack: string }) {
    if (window.trackJs && window.trackJs.track) {
      window.trackJs.console.log(`stacktrace:\n${info.componentStack}`);
    }
    this.props.setError(error);
  }

  render() {
    const { props, type } = this.props;

    return <Modal type={type} modalProps={props} />;
  }
}

export default connect<Props, OwnProps, _, _, _, _>(
  state => state.modal,
  { setError }
)(ModalRoot);
